// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2zt4K","errors":"Errors_errors__1Z2OT"};